import { GRANTED_FPS } from "../constants";

export function hasVideoExtraFrames(ActualFrameCount: number, ActualLength: number): number {    
    if (typeof ActualLength === 'number') {
      return ActualFrameCount - GRANTED_FPS * Math.floor(ActualLength);
    }
    return 0;
};